import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { supabase } from '../lib/supabase';

export default function ConfirmPage() {
  const { token } = useParams();
  const [state, setState] = useState('loading'); // loading | success | error

  useEffect(() => {
    async function confirm() {
      const { data: sub, error } = await supabase
        .from('subscribers')
        .select('id, confirmed')
        .eq('confirmation_token', token)
        .single();

      if (error || !sub) { setState('error'); return; }

      if (sub.confirmed) { setState('success'); return; }

      const { error: updateError } = await supabase
        .from('subscribers')
        .update({ confirmed: true, confirmation_token: null })
        .eq('id', sub.id);

      if (updateError) { setState('error'); return; }

      setState('success');
    }
    confirm();
  }, [token]);

  if (state === 'loading') return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',background:'#f0f2f8'}}>
      <div style={{textAlign:'center'}}>
        <div style={{width:32,height:32,border:'3px solid #e2e5f0',borderTopColor:'#000F9F',borderRadius:'50%',animation:'spin 0.6s linear infinite',margin:'0 auto 12px'}}></div>
        <style>{`@keyframes spin{to{transform:rotate(360deg)}}`}</style>
        <p style={{color:'#6b7280',fontSize:13}}>Confirming your subscription...</p>
      </div>
    </div>
  );

  if (state === 'error') return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',background:'#f0f2f8'}}>
      <div style={{textAlign:'center',background:'#fff',padding:40,borderRadius:10,maxWidth:400}}>
        <div style={{fontSize:40,marginBottom:12}}>🔗</div>
        <h2 style={{fontFamily:'Syne,sans-serif',color:'#000F9F',marginBottom:8}}>Invalid Link</h2>
        <p style={{color:'#6b7280',fontSize:13}}>This confirmation link is not valid or has already been used. Contact your Nimble representative for assistance.</p>
      </div>
    </div>
  );

  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh',background:'#f0f2f8'}}>
      <div style={{textAlign:'center',background:'#fff',padding:40,borderRadius:10,maxWidth:400}}>
        <div style={{fontSize:40,marginBottom:12}}>✅</div>
        <h2 style={{fontFamily:'Syne,sans-serif',color:'#000F9F',marginBottom:8}}>You're confirmed!</h2>
        <p style={{color:'#6b7280',fontSize:13}}>You'll start receiving shipment updates from Nimble. Keep an eye on your inbox!</p>
        <p style={{color:'#9ca3af',fontSize:12,marginTop:16}}>nimbleinc.net</p>
      </div>
    </div>
  );
}
